import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowUpIcon = createIconComponent(
  'ArrowUpIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21L12 3M12 3L19 10M12 3L5 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
